// WMS示例接口
import request from "@/utils/request";

// 获取仓库数据权限列表
export function getWarehousePermission() {
  return request({
    url: process.env.VUE_APP_API_PREFIX + '/wms/base/getWarehousePermission',
    method: "POST"
  });
}

// 更新当前选中仓库数据全新
export function setWarehouseToRedis(data) {
  return request({
    url: process.env.VUE_APP_API_PREFIX + '/wms/base/setWarehouseToRedis',
    method: "POST",
    data: data
  });
}